import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthContext from "../context/AuthContext";

const Login = () => {
    const { login, auth } = useContext(AuthContext);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const { data } = await axios.post("https://wildberries-web-test.up.railway.app/api/auth/login", { username, password });
            login(data.token);
            navigate("/");
        } catch (error) {
            toast.error("Feil brukernavn eller passord.");
        }
    };

    useEffect(() => {
        if (auth){
            navigate("/")
        }
    }, [auth])


    return (
        <div className="h-screen flex items-center justify-center bg-gray-100">
            <ToastContainer position="top-right" autoClose={3000} />
            <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
                <h2 className="text-2xl font-bold text-center mb-6 text-gray-700">Admin Innlogging</h2>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-gray-700 font-medium">Brukernavn</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="w-full p-3 border rounded focus:ring focus:ring-green-200"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-gray-700 font-medium">Passord</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full p-3 border rounded focus:ring focus:ring-green-200"
                            required
                        />
                    </div>
                    <button type="submit" className="w-full bg-green-600 text-white py-3 rounded hover:bg-green-700">
                        Logg inn
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
